export const MOBILE_PROGRESS_FOOTER_HEIGHT = 76;
export const PUBLIC_OFFICE_REQUEST_HEADER_HEIGHT_MOBILE = 72;
export const PROGRESS_FOOTER_HEIGHT = 96;
export const INITIAL_NUMBER_STEPPER_SHEET_HEIGHT = 260 + MOBILE_PROGRESS_FOOTER_HEIGHT;
export const BOTTOM_SHEET_PADDING_TOP = 24;
export const BOTTOM_SHEET_PADDING_BOTTOM = 36;
